module.exports = {"attributes":{"width":"25px","height":"24px","viewBox":"0 0 25 24","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"},"content":"<g>         <rect transform=\"translate(12.500000, 12.000000) rotate(-315.000000) translate(-12.500000, -12.000000) \" x=\"-3\" y=\"11\" width=\"31\" height=\"2\"></rect>         <rect transform=\"translate(12.500000, 12.000000) rotate(-585.000000) translate(-12.500000, -12.000000) \" x=\"-3\" y=\"11\" width=\"31\" height=\"2\"></rect>     </g>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/cross.svg
// module id = 1393
// module chunks = 0